import { gql } from '@apollo/client';
export const GET_API_CREDENTIALS_NAME = 'GetCredentials';
export const GET_API_CREDENTIALS = gql `
  query ${GET_API_CREDENTIALS_NAME}($merchantId: String!) {
    merchantApiCredentials(merchantId: $merchantId) {
      id
      createdAt
      properties {
        name
        value
      }
    }
  }
`;
export const CREATE_API_CREDENTIALS = gql `
  mutation createMerchantApiCredentials($merchantId: ID!) {
    createMerchantApiCredentials(input: { merchantId: $merchantId }) {
      id
      properties {
        name
        value
      }
    }
  }
`;
